import React from 'react';
import { useTheme } from '../utils/ThemeContext';

export function ScoreBadge({ score, par, zeroAsEagle = false }) {
  const { theme } = useTheme();
  const borderColor = theme.primary;

  const plainSpan = <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 22, height: 22 }}>{score}</span>;

  if (score == null || par == null) return plainSpan;
  if (Number(score) === 0 && !zeroAsEagle) return plainSpan;
  const diff = Number(score) === 0 ? -2 : Number(score) - Number(par);

  if (diff <= -2) {
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 26, height: 26,
        borderRadius: '50%',
        border: `1px solid ${borderColor}`,
        fontSize: '12px',
      }}>
        <span style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: 18, height: 18,
          borderRadius: '50%',
          border: `1px solid ${borderColor}`,
          fontSize: '12px',
        }}>{score}</span>
      </span>
    );
  }
  if (diff === -1) {
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 22, height: 22,
        borderRadius: '50%',
        border: `1px solid ${borderColor}`,
        fontSize: '12px',
      }}>{score}</span>
    );
  }
  if (diff === 1) {
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 22, height: 22,
        border: `1px solid ${borderColor}`,
        fontSize: '12px',
      }}>{score}</span>
    );
  }
  if (diff >= 2) {
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 26, height: 26,
        border: `1px solid ${borderColor}`,
        fontSize: '12px',
      }}>
        <span style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: 18, height: 18,
          border: `1px solid ${borderColor}`,
          fontSize: '12px',
        }}>{score}</span>
      </span>
    );
  }
  return plainSpan;
}
